// extracted by mini-css-extract-plugin
module.exports = {"container":"Textarea_container__3qliE"};